import request from '@/utils/request/request'

export function login(data) {
  return request({
    url: '/v1/login',
    method: 'post',
    data
  })
}
export function getProfile(data) {
  return request({
    url: '/v1/profile',
    method: 'get',
    data
  })
}

export function setModify(data) {
  return request({
    url: '/v1/modify',
    method: 'post',
    data
  })
}




export function vcode(data) {
  return request({
    url: '/v1/vcode',
    method: 'get',
    data
  })
}


export function forget(data) {
  return request({

    url: '/v1/forget',
    method: 'post',
    data
  })
}

export function avatar(data) {
  return request({

    url: '/v1/avatar',
    method: 'post',
    data
  })
}
export function notes(data) {
  return request({
    url: '/v1/pc_notes',
    method: 'get',
    data
  })
}

export function myOrders(data) {
  return request({
    url: '/v1/orders',
    method: 'get',
    data
  })
}

export function submitInvoiceInforApi(data) {
  return request({
    url: '/v1/receipt',
    method: 'post',
    data
  })
}

export function userinfo(data) {
  return request({
    url: '/v1/userinfo',
    method: 'get',
    data
  })
}

export function password(data) {
  return request({
    url: '/v1/password',
    method: 'post',
    data
  })
}

export function cancelOrder(data) {
  return request({
    url: '/v1/cancel',
    method: 'get',
    data
  })
}

export function requestRefund(data) {
  return request({
    url: '/v1/refund',
    method: 'post',
    data
  })
}


export function agreement(data) {
  return request({
    url: '/v1/agreement',
    method: 'get',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js